import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faSpinner } from '@fortawesome/pro-solid-svg-icons'

import { useTranslationRankmi } from 'helpers/translations.helper'
import PublishButton from '../PublishButton'
import {
  BackButton,
  FormFooter,
  PreviewButton,
  PrimaryActions,
  SaveDraftButton,
} from './styled'

interface LessonsFormFooterProps {
  draggable: boolean
  buttonLoading: boolean
  publishDisabled?: boolean
  shouldConfirmNormativePublish?: boolean
  onBack: () => void
  onPreview: () => void
  onSaveDraft: () => void
}

export const LessonsFormFooter: React.FC<LessonsFormFooterProps> = ({
  draggable,
  buttonLoading,
  publishDisabled = false,
  shouldConfirmNormativePublish = false,
  onBack,
  onPreview,
  onSaveDraft,
}) => {
  const t = useTranslationRankmi({
    prefix: 'administration.lessons.buttons',
  })

  const actionsDisabled = buttonLoading || draggable

  return (
    <FormFooter>
      <BackButton
        type="button"
        disabled={draggable}
        onClick={() => !draggable && onBack()}
      >
        <FontAwesomeIcon icon={faArrowLeft} aria-hidden />
        {t('back')}
      </BackButton>
      <PrimaryActions>
        <PreviewButton
          type="button"
          disabled={actionsDisabled}
          onClick={() => !actionsDisabled && onPreview()}
        >
          {t('preview')}
        </PreviewButton>
        <SaveDraftButton
          type="button"
          disabled={actionsDisabled}
          onClick={() => !actionsDisabled && onSaveDraft()}
        >
          {buttonLoading ? (
            <FontAwesomeIcon icon={faSpinner} spin aria-hidden />
          ) : null}
          {t('saveDraft')}
        </SaveDraftButton>
        <PublishButton
          draggable={draggable}
          disabled={publishDisabled}
          shouldConfirmNormativePublish={shouldConfirmNormativePublish}
        />
      </PrimaryActions>
    </FormFooter>
  )
}

export default LessonsFormFooter
